import classNames from 'classnames';

function Input({ className = '', ...props }) {
  return (
    <>
      <input className={classNames('border-gray-2 px-3 gray-1 font-14px br-4 custom-input', className)} {...props} />
      {/* {error && <div className='font-12px red'>{error}</div>} */}
      <style jsx>
        {`
          .custom-input {
            padding-top: 1.4rem;
            padding-bottom: 1.4rem;
            font-size: 14px;
            line-height: 18px;
          }
          .custom-input:placeholder {
            color: #79747e;
            font-weight: 400;
          }
          .custom-input:focus-visible {
            border: 1px solid #938f96;
            outline: none;
          }
          .custom-input:read-only {
            background: rgba(170, 191, 195, 0.3);
            color: #606a7b;
          }
        `}
      </style>
    </>
  );
}

export default Input;
